import { forwardRef, type Ref, type SVGProps } from "react";
const IconPanoramaFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m25 16.42-2.59 2.63.3.3a1 1 0 0 1 0 1.44 1 1 0 0 1-1.42 0L18 17.44l-7.56 7.7c1.76-.14 3.66-.23 5.56-.23h1l2 .09 1 .05c1.6.09 3.12.22 4.47.37 1.9.21 3.47.43 4.46.59H29a1 1 0 0 0 .17 0h.16a.7.7 0 0 0 .21-.12l.13-.08a.7.7 0 0 0 .16-.22 1 1 0 0 0 .08-.11A1 1 0 0 0 30 25v-3.49Z"
    />
    <path
      fill="currentColor"
      d="M29.91 6.6a1 1 0 0 0-.08-.11.7.7 0 0 0-.16-.22l-.13-.08a.7.7 0 0 0-.21-.12h-.16A1 1 0 0 0 29 6h-.15c-1 .16-2.56.38-4.46.59-1.35.15-2.87.28-4.47.37L19 7l-2 .07h-1A88 88 0 0 1 3.15 6H3a1 1 0 0 0-.17 0h-.16a.7.7 0 0 0-.21.12l-.13.08a.7.7 0 0 0-.16.22 1 1 0 0 0-.08.11A1 1 0 0 0 2 7v18a1 1 0 0 0 .09.42 1 1 0 0 0 .08.11.7.7 0 0 0 .16.22l.13.08a.7.7 0 0 0 .21.12h.16A1 1 0 0 0 3 26h.15c.94-.15 2.4-.36 4.17-.56l10-10.15a1 1 0 0 1 1.42 0L21 17.61l3.29-3.35a1 1 0 0 1 1.42 0L30 18.63V7a1 1 0 0 0-.09-.4M9 16a2 2 0 1 1 2-2 2 2 0 0 1-2 2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPanoramaFilledSVG);
ForwardRef.displayName = "IconPanoramaFilled";
export { ForwardRef as IconPanoramaFilled };
